import request from "@/utils/request";

export function login(username, password) {
  let params = new URLSearchParams();
  params.append("account", username);
  params.append("password", password);
  return request({
    url: "/login",
    method: "post",
    data: params
  });
}

export function getMenus() {
  return request({
    url: "/sys-resource/findMenus",
    method: "get"
  });
}

export function getInfo(id) {
  return request({
    url: `/role/${id}`,
    method: "get"
  });
}

export function logout() {
  return request({
    url: "/logout",
    method: "get"
  });
}

export function fetchList(params) {
  return request({
    url: "/admin/list",
    method: "get",
    params: params
  });
}

export function createAdmin(data) {
  return request({
    url: "/admin/register",
    method: "post",
    data: data
  });
}

export function updateAdmin(id, data) {
  return request({
    url: "/admin/update/" + id,
    method: "post",
    data: data
  });
}

export function updateStatus(id, params) {
  return request({
    url: "/admin/updateStatus/" + id,
    method: "post",
    params: params
  });
}

export function deleteAdmin(id) {
  return request({
    url: "/admin/delete/" + id,
    method: "post"
  });
}

export function getRoleByAdmin(id) {
  return request({
    url: "/admin/role/" + id,
    method: "get"
  });
}

export function allocRole(data) {
  return request({
    url: "/admin/role/update",
    method: "post",
    data: data
  });
}

// 修改密码
export function changePassword(params) {
  return request({
    url: "/sys-backer/modify-password",
    method: "put",
    data: params
  });
}

// 验证码登录
export function getSmsCodeLogin(params) {
  return request({
    url: `/sms/login`,
    method: "post",
    params,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    }
  });
}



// WEBPACK FOOTER //
// ./src/api/login.js